import React from "react";
import styled from "styled-components";

const Txt = styled.p`
  margin-bottom: 30px;
  line-height: 1.3rem;
  font-weight: 300;
`;

const TxtBox = ({ children }) => {
  return <Txt className="gray">{children}</Txt>;
};

export default TxtBox;
